var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("page-header"),
      _c(
        "section",
        { staticClass: "error-section" },
        [
          _c("page-limiter", [
            _c("div", { staticClass: "error-section__body" }, [
              _vm.error.statusCode === 404
                ? _c(
                    "div",
                    { staticClass: "error-tile" },
                    [
                      _c("div", { staticClass: "error-tile__title" }, [
                        _vm._v("404")
                      ]),
                      _c("div", { staticClass: "error-tile__message" }, [
                        _vm._v("Мы не можем найти страницу, "),
                        _c("br"),
                        _vm._v(" которую вы ищете.")
                      ]),
                      _c(
                        "btn",
                        {
                          staticClass: "btn btn--primary error-tile__btn",
                          attrs: { link: "/", tag: "link" }
                        },
                        [
                          _vm._v("\n\t\t\t\t\t\tНа главную\n\t\t\t\t\t\t"),
                          _c("icon-arrow", {
                            staticClass: "error-tile__btn-icon"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        1
      ),
      _c("page-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5ea9138", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5ea9138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/error.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d5ea9138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/error.vue
// module chunks = 5